import { render } from "./ShareComponent.vue?vue&type=template&id=d7f246e8&ts=true"
import script from "./ShareComponent.vue?vue&type=script&lang=ts"
export * from "./ShareComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__